import { cn } from "@productlane/lib/src/cn"

export const PAGE_BLEED = "-mx-5 sm:-mx-8"
export const PAGE_GUTTER = "px-5 sm:px-8"

// Bands and rows sit 8px inside the page edge, so their padding is the page
// gutter minus that inset and every label lines up with the page title.
export const INSET = "mx-2"
export const INSET_PADDING = "px-3 sm:px-6"

// Below lg only the name, usage, and menu columns fit.
export const CHANNEL_GRID = cn(
	"grid grid-cols-[minmax(0,1fr)_160px_28px] items-center gap-4",
	"lg:grid-cols-[minmax(0,1fr)_170px_150px_170px_160px_28px]",
	INSET,
	INSET_PADDING,
)

export const META_CELL = "hidden min-w-0 items-center gap-1.5 lg:flex"

export const GROUP_BAND = cn(
	"flex h-8 items-center gap-2 rounded-md bg-gray-150 text-xs font-medium text-secondary dark:bg-gray-850",
	INSET,
	INSET_PADDING,
)

export const ROW_HOVER = "hover:bg-gray-50 dark:hover:bg-gray-900"

// Cancels the settings layout's bottom padding, so the page fills to the window's bottom
// edge and the pinned note sits in the same spot for a short list or a long one.
export const FILL_TO_BOTTOM = "-mb-8 sm:-mb-28"

export const PINNED_NOTE = cn(
	"sticky bottom-0 z-10 mt-auto border-t border-gray-200 bg-gray-100 py-3 text-xs text-tertiary dark:border-gray-700/80 dark:bg-gray-950",
	PAGE_GUTTER,
)
